import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthCoverSignup = () => {

    const navigate = useNavigate();
    const [time, setTime] = useState(60);
    const inputsRef = useRef([]);
    useEffect(() => {
        const interval = setInterval(() => {
            setTime((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    navigate("/auth-cover-signin");
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [navigate]);

    const handleKeyUp = (e, index) => {
        const { key, target } = e;

        if (/^[0-9]$/.test(key)) {
            if (index < inputsRef.current.length - 1) {
                inputsRef.current[index + 1].focus();
            }
        }

        if (key === "Backspace" && !target.value) {
            if (index > 0) {
                inputsRef.current[index - 1].focus();
            }
        }
    };

    return (
        <>
            <div className="wrapper">
                <div className="section-authentication-cover">
                    <div className>
                        <div className="row g-0">
                            <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">
                                <div className="card shadow-none bg-transparent shadow-none rounded-0 mb-0">
                                    <div className="card-body">
                                        <img src="images/login-images/register-cover.png" className="img-fluid auth-img-cover-login" width={550} alt />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">
                                <div className="card rounded-0 m-3 shadow-none bg-transparent mb-0">
                                    <div className="card-body p-sm-5">
                                        <div className>
                                            <div className="mb-3 text-center">
                                                <img src="images/login-logo.jpeg" width="auto" alt />
                                            </div>
                                            <div className="text-center mb-4">
                                                <p className="mb-0 font-22">Enter your verification code</p>
                                                <p>We’ve sent an invite to your registered email.</p>
                                            </div>
                                            <div className="form-body">
                                                <form className="row g-3" id="jQueryValidationForm" method="post3" action="/auth-cover-reset-password">
                                                    <div className="col-12">
                                                        <div className="verification-code--inputs d-flex gap-2">
                                                            {[...Array(6)].map((_, index) => (
                                                                <input
                                                                    key={index}
                                                                    type="text"
                                                                    maxLength="1"
                                                                    className="form-control text-center"
                                                                    ref={(el) => (inputsRef.current[index] = el)}
                                                                    onKeyUp={(e) => handleKeyUp(e, index)}
                                                                />
                                                            ))}
                                                        </div>
                                                        <div className="timer-box mb-2 text-center">Resend Code in: <b> <span id="time-chnge">{time}</span> second</b></div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-grid">
                                                            <button type="submit" className="btn btn-primary">Verify</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default AuthCoverSignup